import { AuthService } from "@okta/okta-react";

const OKTA_DOMAIN = process.env.REACT_APP_DOMAIN;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const CALLBACK_PATH = "/login/callback";

const ISSUER = `https://${OKTA_DOMAIN}.okta.com/oauth2/default`;
const HOST = window.location.host;
const protocol = process.env.NODE_ENV === "development" ? "http" : "https";
const REDIRECT_URI = `${protocol}://${HOST}${CALLBACK_PATH}`;
const SCOPES = "openid profile email";

export const authentication = new AuthService({
  issuer: ISSUER,
  clientId: CLIENT_ID,
  redirectUri: REDIRECT_URI,
  scope: SCOPES.split(/\s+/),
  tokenManager: {
    autoRenew: true,
  },
  isAuthenticated: async () => {
    const idToken = await authentication.getTokenManager().get("idToken");
    const accessToken = await authentication.getTokenManager().get("accessToken");

    if (Math.floor(Date.now() / 1000) > accessToken?.expiresAt) {
      // eslint-disable-next-line no-console
      console.log("accessToken expired");
      return false;
    }

    if (Math.floor(Date.now() / 1000) > idToken?.expiresAt) {
      // eslint-disable-next-line no-console
      console.log("idToken expired");
      return false;
    }

    return !!(idToken && accessToken);
  },
});
